import React from 'react';

const ArrivalTimeTag = ({ color, text }: { color: 'red' | 'green'; text: string }) => {
  const styles = {
    green: 'text-[#46AE31] bg-[#EAF8E7] border-[#A8E39C]',
    red: 'text-[#E60A2B] bg-[#FEE2E6] border-[#FCB6C0]'
  };
  return (
    <div
      className={`border rounded-[40px] text-2xs leading-[19px] px-3 py-1 min-w-[60px] text-center ${
        color === 'green' ? styles.green : styles.red
      }`}>
      {text}
    </div>
  );
};

export default ArrivalTimeTag;
